var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"planboard-holder"},[_c('TopActions'),_c('FetchErrorTransition',{staticStyle:{"display":"block"},attrs:{"isFetching":_vm.isPending,"error":_vm.fetchError}},[_c('PlanboardCalendar')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }